"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getOrigin = () => {
    const currentScript = document.currentScript;
    return currentScript
        ? new URL(currentScript.src).origin
        : '';
};
const themeImagesPath = `${getOrigin()}/o/knowledge-base-theme/images`;
const getTimeZone = () => {
    const dateTimeFormat = new Intl.DateTimeFormat();
    const { timeZone } = dateTimeFormat.resolvedOptions();
    return timeZone;
};
const isMobile = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('mobile') || (ua.includes('android') && ua.includes('nexus'));
};
const CommonContext = {
    languageId: window.navigator.language.slice(0, 2),
    languageTag: window.navigator.language,
    contextPath: '',
    themeImagesPath,
    timeZone: getTimeZone(),
    spriteMapPath: `${themeImagesPath}/clay/icons.svg`,
    graphqlEndpoint: `${getOrigin()}/o/graphql`,
    isLR: false,
    isMobile: isMobile(),
    origin: getOrigin(),
    pageId: '',
    scopeGroupId: '',
    layoutUrl: '',
    navigatePath(path) {
        const url = new URL(path, window.location.toString());
        const newPath = url.toString().match(/:\/\/[^/]+(\/.*)/)[1];
        window.location.assign(newPath);
    },
};
exports.default = CommonContext;
//# sourceMappingURL=common.js.map